export const JSON_ONE1 = {
   
  
    
        "txn_response": "178HlkzAxG/cRWpritHpKst",
        "pg_details": "VK4tENSSI56ldeZDZUXiWAGw",
        "fraud_details": "dm/MWnnfLo4jl5OLQhPfOQ==",
        "other_details": "a6Fygpz6IpE2xCTI2qJoMw=="
        }

